// SPA-routed pages mounted in lieu of the forecast App.vue chrome.
//
// Background: App.vue is the root component AND the route component for `/`
// (see main.ts), but it does not contain a <router-view>. So routes other
// than `/` cannot be projected via vue-router and have to be mounted as the
// root component instead. The map here is the single source of truth for
// which paths get a non-App root.
//
// The map is currently empty — Phase 1 of #159 retired the Android Custom
// Tab passkey landing page (#161) in favour of a native CredentialManager
// bridge. The signature is kept so a future root-mounted page can be added
// without touching call sites.

import type { Component } from 'vue'

export const ROOT_BY_PATH: Record<string, Component> = {}

export function pickRoot(pathname: string, fallback: Component): Component {
  return ROOT_BY_PATH[pathname] ?? fallback
}
